<script setup lang="ts">
import { useRouter } from "vue-router";
import Button from "@/components/Base/Button";

const router = useRouter();
const goHome = () => {
  router.push("/");
};
</script>

<template>
  <div class="py-10 md:py-20">
    <div class="container relative z-10 text-center">
      <div class="text-3xl font-medium pt-20 px-10 xl:px-0">
        404 - Page Not Found
      </div>
      <div class="mt-5 text-slate-500">
        The page you are looking for does not exist.
      </div>
      <div class="mt-10">
        <Button @click="goHome" variant="primary"> Go Home </Button>
      </div>
    </div>
  </div>
</template>
